// Bakım-Onarım tekil detay PDF'leri (Ödenek talebi + Doğrudan Temin) — detay kartıyla aynı bölümler
import { startReport, addHeading, addTable, addKpis, addParagraph, finishReport, stamp } from './reportPdf';
import { tesisTuruText } from './tesisTuru';
import { alimTuruLabel, fmtTarih, butceTertibiText, firmaTeklifleri, enDusukTeklif, parseTL, toTLString } from '../components/modules/bakim-onarim/detayOrtak';

const GRAY = [107, 114, 128];
const kv = (pairs) => {
  const rows = [];
  for (let i = 0; i < pairs.length; i += 2) rows.push([pairs[i][0], pairs[i][1] || '-', pairs[i + 1]?.[0] || '', pairs[i + 1]?.[1] || (pairs[i + 1] ? '-' : '')]);
  return rows;
};
const section = (ctx, title, pairs) => {
  addHeading(ctx, title, 1);
  addTable(ctx, ['Alan', 'Değer', 'Alan', 'Değer'], kv(pairs), { fontSize: 8, columnStyles: { 0: { textColor: GRAY, cellWidth: 40 }, 2: { textColor: GRAY, cellWidth: 40 } } });
};
const safeName = (s) => String(s || '').replace(/[^0-9A-Za-zÇĞİÖŞÜçğıöşü_-]+/g, '-').slice(0, 40);

export function exportOdenekDetayPDF(r, { displayMoney, dtLinked = false }) {
  const money = (v) => displayMoney(v) || '-';
  const ctx = startReport({ title: `Ödenek Talebi Detay Raporu${r.talep_yazi_no ? ` — ${r.talep_yazi_no}` : ''}`, subtitle: r.isin_adi || '', orientation: 'portrait', meta: 'Bakım-Onarım Modülü' });
  addKpis(ctx, [
    { label: 'Ödenek Tutarı (KDV Dahil)', value: money(r.odenek_tutari) },
    { label: 'Ödenek Durumu', value: r.odenek_durumu || '-' },
    { label: 'Yıl', value: r.yil || '-' },
    { label: 'Doğrudan Temin', value: dtLinked ? 'Aktarıldı' : 'Yok' },
  ]);
  section(ctx, '1. Temel Bilgiler', [
    ['Yıl', r.yil], ['Tesis Türü', tesisTuruText(r.tesis_turu)], ['Tesis Adı', r.tesis_adi], ['İlçe', r.ilce],
    ['Alım Türü', alimTuruLabel(r.alim_turu)], ['İşin Adı', r.isin_adi],
  ]);
  section(ctx, '2. Talep ve Sorumlu', [
    ['Talep Yeri', r.talep_yeri], ['İlgilenen Memur', r.ilgilenen_memur],
    ['Ödenek Talep Tarihi', fmtTarih(r.odenek_talep_tarihi)], ['Talep Yazı No', r.talep_yazi_no],
    ['Bütçe Tertibi', butceTertibiText(r).join(', ')],
  ]);
  section(ctx, '3. Ödenek ve Durum', [
    ['Ödenek Tutarı (KDV Dahil)', money(r.odenek_tutari)], ['Ödenek Durumu', r.odenek_durumu],
    ['Ek Taahhüt Ödenek Durumu', r.ek_taahhut_odenek_durumu], ['Ek Protokol Ödenek Durumu', r.ek_protokol_odenek_durumu],
  ]);
  addHeading(ctx, '4. Açıklama', 1);
  addParagraph(ctx, r.aciklama || '-');
  addParagraph(ctx, dtLinked ? 'Bu talep için Doğrudan Temin kaydı oluşturulmuştur.' : 'Doğrudan Temin bağlantısı yok.', { color: GRAY });
  finishReport(ctx, `odenek-detay-${safeName(r.talep_yazi_no || r.yil)}-${stamp()}.pdf`);
}

export function exportDTDetayPDF(r, { displayMoney }) {
  const money = (v) => displayMoney(v) || '-';
  const odenek = parseTL(r.odenek_tutari); const sozlesme = parseTL(r.sozlesme_bedeli); const odenen = parseTL(r.odenen_tutar);
  const fark = odenek && sozlesme ? odenek - sozlesme : null;
  const kalan = sozlesme ? sozlesme - odenen : null;
  const teklifler = firmaTeklifleri(r);
  const enDusuk = enDusukTeklif(teklifler);
  const isiYapan = (r.isi_yapan_firma || '').trim().toLocaleLowerCase('tr');

  const ctx = startReport({ title: `Doğrudan Temin Detay Raporu${r.yil ? ` — ${r.yil}` : ''}`, subtitle: r.isin_adi || '', orientation: 'portrait', meta: 'Bakım-Onarım Modülü' });
  addKpis(ctx, [
    { label: 'Ödenek Tutarı', value: money(r.odenek_tutari) },
    { label: 'Sözleşme Bedeli (KDV Hariç)', value: money(r.sozlesme_bedeli) },
    { label: 'Ödenen Tutar', value: money(r.odenen_tutar) },
    { label: 'Kalan Ödeme', value: kalan === null ? '-' : money(toTLString(Math.max(kalan, 0))) },
  ]);
  section(ctx, '1. Temel Bilgiler', [
    ['Yıl', r.yil], ['Tesis Türü', tesisTuruText(r.tesis_turu)], ['Tesis Adı', r.tesis_adi], ['İlçe', r.ilce],
    ['Alım Türü', alimTuruLabel(r.alim_turu)], ['Talep Yeri', r.talep_yeri], ['İşin Adı', r.isin_adi], ['Ödenekten Aktarım', r.odenek_id ? 'Evet' : 'Hayır'],
  ]);
  section(ctx, '2. Sorumlular ve Piyasa Araştırması', [
    ['İlgilenen Memur', r.ilgilenen_memur], ['Piyasa Araştırma Görevlileri', (r.piyasa_arastirma_gorevlileri || []).join(', ')],
    ['Bütçe Tertibi', butceTertibiText(r).join(', ')],
  ]);
  addHeading(ctx, '3. Firma Teklifleri', 1);
  if (teklifler.length) {
    addTable(ctx, ['#', 'Firma', 'Teklif', 'Not'], teklifler.map(f => [
      String(f.no), f.adi || '-', money(f.teklif),
      [enDusuk?.no === f.no ? 'En düşük teklif' : '', isiYapan && f.adi.trim().toLocaleLowerCase('tr') === isiYapan ? 'İşi yapan firma' : ''].filter(Boolean).join(' · '),
    ]), { fontSize: 8, columnStyles: { 0: { cellWidth: 8 }, 2: { halign: 'right', cellWidth: 40 } } });
  } else {
    addParagraph(ctx, 'Firma teklifi girilmemiş.', { color: GRAY });
  }
  section(ctx, '4. Sözleşme ve Ödeme', [
    ['İşi Yapan Firma', r.isi_yapan_firma], ['Sözleşme Bedeli (KDV Hariç)', money(r.sozlesme_bedeli)],
    ['İşin Süresi', r.isin_suresi ? `${r.isin_suresi} gün` : ''], ['Ödeme Tarihi', fmtTarih(r.odeme_tarihi)],
    ['Ödeme Belge No', r.odeme_belge_no], ['Ödenen Tutar', money(r.odenen_tutar)],
    ['Ödenek − Sözleşme Farkı', fark === null ? '-' : `${fark < 0 ? '-' : ''}${money(toTLString(Math.abs(fark)))}`], ['Kalan Ödeme', kalan === null ? '-' : money(toTLString(Math.max(kalan, 0)))],
  ]);
  finishReport(ctx, `dogrudan-temin-detay-${safeName(r.yil)}-${stamp()}.pdf`);
}
